import reducer from "./redcuer";
import {
  setSelectedPcpLine,
  setSelectedPcpLineIndex,
  setSelectedPcpRow,
} from "./actions";
import * as pcpSelectionSelectors from "./selectors";

const pcpSelectionReducer = reducer;

export {
  setSelectedPcpLine,
  setSelectedPcpRow,
  setSelectedPcpLineIndex,
  pcpSelectionReducer,
  pcpSelectionSelectors,
};
